import { FormDropdownOption, FormDropdownOptionsWithSections } from "./types";

export const buildOptionsList = <TValue extends string | number>(
    options:
        | FormDropdownOption<TValue>[]
        | FormDropdownOptionsWithSections<TValue>
): FormDropdownOption<TValue>[] => {
    if (Array.isArray(options)) {
        return options;
    }

    return Object.values(options)
        .map((optionSection) => optionSection.options)
        .flat();
};

export const buildOptionsWithSections = <TValue extends string | number>(
    options: FormDropdownOption<TValue>[],
    getSection: (option: FormDropdownOption<TValue>) => {
        sectionTitle: string;
        sectionOrder: number;
    }
): FormDropdownOptionsWithSections<TValue> => {
    return options.reduce((options, option) => {
        const section = getSection(option);

        if (options[section.sectionTitle]) {
            options[section.sectionTitle].options.push(option);
        } else {
            options[section.sectionTitle] = {
                order: section.sectionOrder,
                options: [option],
            };
        }

        return options;
    }, {} as FormDropdownOptionsWithSections<TValue>);
};
